const sliderWrapper = document.querySelector(".slider_wrapper");

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom > 0;
}

function handleScrollEffect() {
  if (sliderWrapper && isInViewport(sliderWrapper)) {
    sliderWrapper.scrollLeft += 200;

    setTimeout(() => {
      sliderWrapper.scrollLeft -= 200;
    }, 1000);
  }
}
window.addEventListener("DOMContentLoaded", () => {
  handleScrollEffect();
});